import { Button } from '@/components/ui/button'

interface Props {
  active: boolean
  completed: number
  total: number
  status: string
  onCancel: () => void
}

export function VinProgressBar({ active, completed, total, status, onCancel }: Props) {
  if (!active && total === 0) return null
  const pct = total > 0 ? Math.round((completed / total) * 100) : 0
  return (
    <div className="rounded-lg border border-blue-200 bg-blue-50 p-4">
      <div className="mb-2 flex items-center justify-between">
        <span className="text-sm font-medium text-blue-900">Načítání dat vozidel z registru</span>
        <span className="text-sm text-blue-700">{completed} / {total}</span>
      </div>
      <div className="mb-2 h-2.5 w-full overflow-hidden rounded-full bg-blue-200">
        <div className="h-full bg-blue-600 transition-all" style={{ width: `${pct}%` }} />
      </div>
      <div className="flex items-center justify-between text-xs text-blue-600">
        <span>{status || (active ? 'Probíhá…' : 'Hotovo')}</span>
        {active && (
          <Button variant="link" size="sm" onClick={onCancel} className="text-xs text-red-600 hover:text-red-800 underline p-0 h-auto">
            Zrušit
          </Button>
        )}
      </div>
    </div>
  )
}
